export const color = {
  primary: {
    // +++ brand colors +++
    mainPurple: '#6B11C9',
    mediumPurple: '#B3A5C3',
    darkPurple: '#100728',
    darkestPurple: '#100728',
    lightPurple: '#C8AEE4',
    lighterPurple: '#F7F0FF',
    lightestPurple: '#FBF5FF',
    // --- brand colors ---
    backgroundLightestGray: '#f9fbfc',
    backgroundLighterGray: '#f6f7f9',
    backgroundLightGray: '#f3f4f9',
    lightGrayDarker: '#dadee2',
    lightGray: '#e8ecf0',
    halfMediumGray: '#b7bcc0',
    mediumGray: '#89939c',
    darkGray: '#999',
    darkestGray: '#494949',
    white: '#fff',
    lightBlack: '#222',
    black: '#000',
    amber: '#ffbf00',
    // Data Attribute Capsule Color
    capsulePurple: '#d8b5ff',
    // old colors TODO: Remove old colors after creation v2
    green: '#0bd4b8',
    gray: '#53565a',
    lightGreen: '#f5fdfb',
    red: '#f00',
  },
  semantic: {
    highlight: '#697ac5',
    highlightLight: '#dee4ff',
    positive: '#689d11',
    positiveLight: '#ecf6da',
    warning: '#A89016',
    warningLight: '#fdf5cd',
    negative: '#9d1111',
    negativeLight: '#ffeaea',
    backgroundNegative: '#FFF6F6',
    neutral: '#89939c',
    neutralLight: '#e8ecf0',
  },
  // old colors TODO: Remove old colors after creation v2
  secondary: {
    base: '#00263a',
    blue: '#0077c8',
    green: '#09edcd',
    orange: '#ff8674',
    gray: '#8c8f96',
    white: '#f6f6f6',
  },
  tertiary: {
    gray: '#d0d0ce',
    white: '#fbfbfb',
  },
  charts: {
    blueLight: '#56bfda',
    blue: '#80c1fa',
    purple: '#796bf6',
    purpleDark: '#6b30cc',
    pink: '#ed71b6',
    orange: '#f9b987',
    red: '#FD6767',
    green: '#86C71C',
  },
};

export const colorV2 = {
  accordion: {
    default: {
      background: '#f3f3f3',

      border: '#f3f3f3',
      icon: {
        stroke: '#5c5c5c',
      },
      text: '#5c5c5c',
    },
  },

  body: {
    background: {
      default: '#f3f3f3',
      alpha50Percent: 'rgba(243, 243, 243, 0.5)',
    },
  },

  breadcrumbs: {
    text: { default: '#5c5c5c', separator: '#444444' },
  },

  button: {
    alternate: {
      background: {
        active: '#f6f7f9',
        default: '#ffffff',
        hover: '#f6f7f9',
      },
      border: {
        active: '#0250d9',
        default: '#dadee2',
        hover: '#0250d9',
      },
      icon: {
        active: '#0250d9',
        default: '#494949',
        hover: '#0250d9',
      },
      text: {
        active: '#0250d9',
        default: '#494949',
        hover: '#0250d9',
      },
    },

    contained: {
      primary: {
        background: {
          active: 'transparent',
          default: 'transparent',
          hover: 'transparent',
        },
        border: {
          active: 'transparent',
          default: 'transparent',
          hover: 'transparent',
        },
        icon: {
          fill: {
            active: '#0250d9',
            default: '#494949',
            hover: '#066afe',
          },
          stroke: {
            active: '#0250d9',
            default: '#494949',
            hover: '#066afe',
          },
        },
        text: {
          active: '#0250d9',
          default: '#494949',
          hover: '#066afe',
        },
      },
      secondary: {
        background: {
          active: '#0250d9',
          default: '#066afe',
          hover: '#0250d9',
        },
        border: {
          active: '#0250d9',
          default: '#066afe',
          hover: '#0250d9',
        },
        icon: {
          fill: {
            active: '#ffffff',
            default: '#ffffff',
            hover: '#ffffff',
          },
          stroke: {
            active: '#ffffff',
            default: '#ffffff',
            hover: '#ffffff',
          },
        },
        text: {
          active: '#ffffff',
          default: '#ffffff',
          hover: '#ffffff',
        },
      },
    },

    default: {
      background: {
        active: '#0250d9',
        default: '#066afe',
        hover: '#0250d9',
      },
      border: {
        active: '#0250d9',
        default: '#066afe',
        hover: '#0250d9',
      },
      icon: {
        active: '#ffffff',
        default: '#ffffff',
        hover: '#ffffff',
      },
      text: {
        active: '#ffffff',
        default: '#ffffff',
        hover: '#ffffff',
      },
    },

    disabled: {
      background: {
        active: '#f6f7f9',
        default: '#f6f7f9',
        hover: '#f6f7f9',
      },
      border: {
        active: '#dadee2',
        default: '#dadee2',
        hover: '#dadee2',
      },
      icon: {
        active: '#dadee2',
        default: '#dadee2',
        hover: '#dadee2',
      },
      text: {
        active: '#dadee2',
        default: '#dadee2',
        hover: '#dadee2',
      },
    },

    icon: {
      fill: {
        default: '#5c5c5c',
        hover: '#444444',
      },
      stroke: {
        default: '#5c5c5c',
        hover: '#444444',
      },
    },

    iconAlternate: {
      background: {
        active: 'transparent',
        default: 'transparent',
        hover: 'transparent',
      },
      border: {
        active: '#0250d9',
        default: '#5c5c5c',
        hover: '#066afe',
      },
      fill: {
        active: '#0250d9',
        default: '#5c5c5c',
        hover: '#066afe',
      },
      stroke: {
        active: '#0250d9',
        default: '#5c5c5c',
        hover: '#066afe',
      },
      text: {
        active: '#0250d9',
        default: '#5c5c5c',
        hover: '#066afe',
      },
    },

    menu: {
      background: {
        default: '#ffffff',
        hover: '#ffffff',
      },
      border: {
        default: '#5c5c5c',
        hover: '#5c5c5c',
      },
      icon: {
        fill: {
          default: '#0250d9',
          hover: '#444444',
        },
        stroke: {
          default: '#0250d9',
          hover: '#444444',
        },
      },
    },

    outlined: {
      primary: {
        background: {
          active: '#ffffff',
          default: '#ffffff',
          hover: '#ffffff',
        },
        border: {
          active: '#0250d9',
          default: '#494949',
          hover: '#066afe',
        },
        icon: {
          fill: {
            active: '#0250d9',
            default: '#494949',
            hover: '#066afe',
          },
          stroke: {
            active: '#0250d9',
            default: '#494949',
            hover: '#066afe',
          },
        },
        text: {
          active: '#0250d9',
          default: '#494949',
          hover: '#066afe',
        },
      },
    },

    switch: {
      background: {
        active: '#0250d9',
        default: '#ffffff',
        hover: '#f3f3f3',
        hoverActive: '#0250d9',
      },
      border: {
        active: '#0250d9',
        default: '#5c5c5c',
        hover: '#5c5c5c',
        hoverActive: '#0250d9',
      },
      icon: {
        active: '#ffffff',
        default: '#ffffff',
        hover: '#ffffff',
        hoverActive: '#ffffff',
      },
      text: {
        active: '#ffffff',
        default: '#0250d9',
        hover: '#03234d',
        hoverActive: '#ffffff',
      },
    },

    tab: {
      background: {
        active: '#ffffff',
        default: '#efefef',
        hover: '#f3f3f3',
        hoverActive: '#ffffff',
      },
      border: {
        active: '#ffffff',
        default: '#ffffff',
        hover: '#ffffff', //'#5c5c5c',
        hoverActive: '#ffffff', // '#5c5c5c',
        separator: '#5c5c5c',
      },
      icon: {
        active: '#ffffff',
        default: '#ffffff',
        hover: '#ffffff',
        hoverActive: '#ffffff',
      },
      text: {
        active: '#0250d9',
        default: '#5c5c5c',
        hover: '#03234d',
        hoverActive: '#0250d9',
      },
    },

    textOnly: {
      text: {
        active: '#03234d',
        default: '#0250d9',
        hover: '#03234d',
      },
    },
  },

  contentModule: {
    border: {
      active: '#0250d9', // '#002775', //'#03234d',
      default: '#0250d9',
      hover: '#a8e3ff', // '#03234d', //'#002775', //'#0250d9',
    },
  },

  contentModuleCard: {
    default: {
      background: {
        default: '#ffffff',
        id: '#dadee2',
      },
      border: {
        active: '#0250d9',
        default: '#ffffff',
        hover: '#0250d9',
        listing: '#dadee2',
      },
      icon: {
        fill: {
          default: '#5c5c5c',
          disabled: '#5c5c5c',
        },
        stroke: {
          default: '#5c5c5c',
          disabled: '#5c5c5c',
        },
      },
      text: {
        default: '#5c5c5c',
        hover: '#5c5c5c',
      },
    },
  },

  dropdown: {
    button: {
      background: {
        active: 'rgba(2, 80, 217, .2)',
        default: '#ffffff',
        hover: 'rgba(2, 80, 217, .2)',
      },
      border: {
        active: '#0250d9',
        default: '#5c5c5c',
        hover: '#0250d9',
      },
      text: {
        alt: '#0250d9',
        default: '#5c5c5c',
        header: '#5c5c5c',
        hover: '#0250d9',
      },
    },

    icon: {
      fill: {
        active: '#0250d9',
        default: '#5c5c5c',
        hover: '#0250d9',
      },
      stroke: {
        active: '#0250d9',
        default: '#5c5c5c',
        hover: '#0250d9',
      },
    },

    list: {
      background: {
        active: 'rgba(2, 80, 217, .2)',
        default: '#ffffff',
        hover: 'rgba(2, 80, 217, .2)',
      },
      border: {
        active: '#0250d9',
        default: '#5c5c5c',
        hover: '#0250d9',
      },
      text: {
        alt: '#0250d9',
        active: '#0250d9',
        default: '#5c5c5c',
        header: '#5c5c5c',
        hover: '#0250d9',
      },
    },
  },

  headers: {
    h1: {
      default: '#022ac0',
    },
    h2: {
      default: '#0250d9',
    },
    h3: {
      default: '#a8e3ff',
    },
    h4: {
      default: '#03234d',
    },
  },

  input: {
    default: {
      background: {
        active: '#ffffff',
        default: '#ffffff',
        disabled: '#f3f3f3',
      },
      border: {
        default: '#cdcdcd',
        disabled: '#dadee2',
      },
      icon: {
        fill: { default: '#747474', disabled: '#747474' },
        stroke: { default: '#747474', disabled: '#747474' },
      },
      text: {
        default: '#747474',
        disabled: '#747474',
        placeholder: '#949494',
      },
    },
    checkbox: {
      background: {
        active: '#0250d9',
        default: '#ffffff',
        hover: '#f3f3f3',
        hoverActive: '#0250d9',
      },
      border: {
        active: '#0250d9',
        default: '#5c5c5c',
        hover: '#5c5c5c',
        hoverActive: '#0250d9',
      },
    },
    file: {
      background: {
        active: 'rgba(2, 80, 217, .2)',
        default: '#ffffff',
        hover: 'rgba(2, 80, 217, .2)',
      },
      border: {
        active: '#0250d9',
        default: '#5c5c5c',
        hover: '#0250d9',
      },
      text: {
        alt: '#0250d9',
        default: '#5c5c5c',
        header: '#5c5c5c',
      },
    },
    radio: {
      background: {
        active: '#0250d9',
        default: '#ffffff',
        hover: '#f3f3f3',
        hoverActive: '#0250d9',
      },

      border: {
        active: '#0250d9',
        default: '#5c5c5c',
        hover: '#5c5c5c',
        hoverActive: '#0250d9',
      },

      bullet: {
        active: '#0250d9',
        default: '#5c5c5c',
        hover: '#949494',
        hoverActive: '#0250d9',
      },
    },
    search: {
      background: {
        default: '#f3f3f3',
      },
      border: {
        default: '#ffffff', //'#cdcdcd',
      },
      text: {
        default: '#747474',
      },
    },
  },

  // link
  link: {
    text: {
      active: '#022ac0',
      default: '#0250d9',
      hover: '#022ac0',
    },
  },

  module: {
    border: {
      active: '#0250d9',
      default: '#0250d9',
      hover: '#a8e3ff',
    },
  },

  navigation: {
    primary: {
      background: {
        active: '#002775',
        default: '#002775',
        hover: '#002775',
      },
      border: {
        active: '#f3f3f3',
        default: '#002775',
        hover: '#f3f3f3',
      },
      icon: {
        fill: {
          active: '#ebebeb',
          default: '#ebebeb',
          hover: '#ebebeb',
        },
        stroke: {
          active: '#ebebeb',
          default: '#ebebeb',
          hover: '#ebebeb',
        },
      },
      text: {
        active: '#ffffff',
        default: '#ffffff',
        hover: '#ffffff',
      },
    },
  },

  panel: {
    background: {
      default: '#ffffff',
    },
  },

  personalizationToken: {
    background: '#a8e3ff',
    border: '#0250d9', // '#a8e3ff',
    text: '#000000',
  },

  popupMenu: {
    background: {
      default: '#ffffff',
      hover: '#ebebeb',
    },
    border: {
      default: '#dadee2',
    },

    option: {
      background: {
        active: '#ebebeb',
        default: '#ffffff',
        hover: '#ebebeb',
      },
      border: {
        active: 'transparent',
        default: '#5c5c5c',
        hover: 'transparent',
      },
      icon: {
        fill: {
          active: '#03234d',
          default: '#5c5c5c',
          hover: '#444444',
        },
        stroke: {
          active: '#03234d',
          default: '#5c5c5c',
          hover: '#444444',
        },
      },
      text: {
        active: '#181818',
        default: '#181818',
        hover: '#181818',
        secondary: '#5c5c5c',
      },
    },
  },

  text: {
    default: '#5c5c5c',
    disabled: '#494949',
    header: '#03234d',
    superSmallCaption: '#89939c',
  },

  userStory: {
    indicator: '#0250d9',
  },
};
